import React from 'react';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  fullPage?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = 'Loading...', 
  size = 'medium',
  fullPage = false 
}) => {
  const sizeClasses = {
    small: 'h-4 w-4 border-2',
    medium: 'h-8 w-8 border-2',
    large: 'h-12 w-12 border-3'
  };

  const containerClasses = fullPage 
    ? 'flex flex-col items-center justify-center h-full min-h-[400px]'
    : 'flex flex-col items-center justify-center py-12';

  return (
    <div className={containerClasses}>
      {/* Holographic Spinner */}
      <div className="relative">
        {/* Outer glow ring */}
        <div className={`${sizeClasses[size]} rounded-full border-blue-500/20 dark:border-blue-400/20 absolute inset-0 animate-pulse`}></div>
        
        {/* Spinning ring */}
        <div 
          className={`
            ${sizeClasses[size]} 
            rounded-full 
            border-transparent 
            border-t-blue-600 
            dark:border-t-blue-400 
            animate-spin
          `}
          style={{ animationDuration: '0.8s' }}
        ></div>
        
        {/* Inner dot */}
        <div 
          className={`
            absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2
            ${size === 'small' ? 'w-1 h-1' : size === 'medium' ? 'w-2 h-2' : 'w-3 h-3'}
            bg-blue-600 dark:bg-blue-400 rounded-full
            animate-pulse
          `}
        ></div>
      </div>

      {/* Loading text with fade animation */}
      {message && (
        <p 
          className="mt-4 text-sm font-sans text-gray-600 dark:text-gray-400 animate-pulse"
          style={{ animationDuration: '1.5s' }}
        >
          {message}
        </p>
      )}

      {/* Holographic scanline effect */}
      <div className="mt-2 w-32 h-0.5 bg-gradient-to-r from-transparent via-blue-500/30 dark:via-blue-400/30 to-transparent animate-pulse"></div>
    </div>
  );
};

export default LoadingSpinner;
